import BottomBarEnum from '../enumerators/bottom-bar.enum'

export default class BottomBarComponent {
    constructor() {
        BottomBarComponent.scrollReveal()
        BottomBarComponent.responsiveComportment()
    }

    static scrollReveal() {
        const bottomBarWrapper = $(BottomBarEnum.BOTTOMBAR).parent()

        if (bottomBarWrapper.length > 0) {
            const elementOffsetTop = $(bottomBarWrapper).offset().top

            if (window.matchMedia('(max-width: 1000px)').matches && bottomBarWrapper.length > 0) {
                $(window).on('scroll', () => {
                    const elementOffsetBottom =
                        $(bottomBarWrapper).outerHeight(true) + elementOffsetTop
                    const offset = 150
                    const top = $(window).scrollTop()
                    const bottom = top + $(window).height()

                    if (bottom > elementOffsetTop + offset && bottom < elementOffsetBottom) {
                        $(BottomBarEnum.BOTTOMBAR).removeClass('hide')
                    } else {
                        $(BottomBarEnum.BOTTOMBAR).addClass('hide')
                    }
                })
            }
        }
    }

    static responsiveComportment() {
        window.addEventListener('orientationchange', () => BottomBarComponent.scrollReveal())
        window.addEventListener('resize', () => BottomBarComponent.scrollReveal())
    }
}
